// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.flow-assistant-root {
  position: fixed;
  right: 0;
  top: 64px;
  height: calc(100vh - 64px);
  z-index: 990;
  font-family: inherit;
  pointer-events: none;
}

/* Keep chatbot icons aligned with app-wide Material icon sizing/font. */
.flow-assistant-root mat-icon {
  font-family: "Material Icons", "Material Icons Outlined" !important;
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.flow-assistant-panel {
  position: relative;
  width: min(400px, 32vw);
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.08);
  border-left: 1px solid #e0e0e0;
  overflow: hidden;
  pointer-events: auto;
}

.flow-assistant-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 16px 14px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;
}

.flow-assistant-header-main {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flow-assistant-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.flow-assistant-header-icon {
  color: #5ea1d8;
}

.flow-assistant-header-icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.flow-assistant-header-icon--close {
  color: #212427;
}

.flow-assistant-header-icon--delete {
  color: #d32f2f;
}

.flow-assistant-header-icon:hover {
  background: #f5f5f5;
}

.flow-assistant-header-icon--close:hover {
  background: rgba(94, 161, 216, 0.12);
}

.flow-assistant-header-icon--delete:hover {
  background: rgba(211, 47, 47, 0.12);
}

.flow-assistant-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #5ea1d8;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}

.flow-assistant-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.flow-assistant-title {
  font-weight: 700;
  font-size: 18px;
  color: #212427;
}

.flow-assistant-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #606060;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #5ea1d8;
  flex: 0 0 auto;
}

.flow-assistant-banner {
  padding: 12px 16px 10px;
  background: #fff;
}

.flow-assistant-banner-label {
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #5ea1d8;
}

.flow-assistant-hint {
  margin: 0;
  font-size: 12px;
  color: #606060;
  line-height: 1.45;
}

.flow-assistant-hint-title {
  font-weight: 700 !important;
  font-style: italic;
  color: #212427;
  display: inline;
}

.flow-assistant-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px 14px;
  background: #ffffff;
}

.flow-assistant-messages::after {
  content: "";
  display: table;
  clear: both;
}

.flow-assistant-empty {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 6px 0 18px;
}

.flow-assistant-welcome-card {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 18px 16px;
  color: #212427;
}

.welcome-title {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
}

.welcome-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
  color: #606060;
}

.flow-assistant-section-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #5ea1d8;
}

.flow-assistant-suggestions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.flow-assistant-blogs {
  margin: 0;
  padding: 12px 16px 10px;
  border-bottom: 1px solid #eef2f5;
  background: #fafbfc;
  flex-shrink: 0;
  max-height: 160px;
  overflow-y: auto;
}

.flow-assistant-blogs .flow-assistant-section-label {
  margin-bottom: 8px;
}

.flow-assistant-blog-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.flow-assistant-blog-card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  border: 1px solid #e0e0e0;
  background: #fff;
  border-radius: 14px;
  padding: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.flow-assistant-blog-card:hover:not(:disabled) {
  border-color: #5ea1d8;
  background: #f7fbfe;
}

.flow-assistant-blog-card:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.flow-assistant-blog-cover {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  object-fit: cover;
  flex-shrink: 0;
  background: #f0f0f0;
}

.flow-assistant-blog-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.flow-assistant-blog-title {
  font-size: 13px;
  font-weight: 600;
  color: #212427;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flow-assistant-blog-author {
  font-size: 11px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.suggestion-card {
  width: 100%;
  text-align: left;
  border: 1px solid #e0e0e0;
  background: #f5f5f5;
  border-radius: 20px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
}

.suggestion-card:disabled {
  cursor: not-allowed;
}

.suggestion-card--primary {
  background: #ffffff;
  border-color: #5ea1d8;
}

.suggestion-title {
  font-size: 14px;
  line-height: 1.45;
  color: #212427;
}

.suggestion-action {
  align-self: flex-start;
  min-width: 150px;
  padding: 10px 18px;
  border-radius: 999px;
  background: #5ea1d8;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}

.suggestion-card:not(.suggestion-card--primary) .suggestion-action {
  background: #fff;
  color: #5ea1d8;
  border: 1px solid #5ea1d8;
}

.flow-assistant-line {
  margin-bottom: 12px;
}

.flow-assistant-line .bubble {
  display: inline-block;
  max-width: 88%;
  padding: 10px 14px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.flow-assistant-line.user .bubble {
  background: #5ea1d8;
  color: #fff;
  margin-left: auto;
  float: right;
  clear: both;
}

.flow-assistant-line.assistant .bubble {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  clear: both;
}

.flow-assistant-meta {
  clear: both;
  margin-top: 6px;
  font-size: 11px;
  color: #606060;
}

.flow-assistant-line.user .flow-assistant-meta {
  text-align: right;
}

.citations {
  clear: both;
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.citations-label {
  color: rgba(0, 0, 0, 0.5);
}

.citation-link {
  color: #1976d2;
  text-decoration: none;
}

.citation-link:hover {
  text-decoration: underline;
}

.citation-text {
  color: rgba(0, 0, 0, 0.65);
}

.flow-assistant-loading {
  display: flex;
  justify-content: center;
  padding: 12px;
}

.flow-assistant-error {
  margin: 0 16px 10px;
  padding: 10px 12px;
  font-size: 13px;
  color: #c62828;
  background: #ffebee;
  border-radius: 12px;
}

.flow-assistant-input-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 16px;
  border-top: 1px solid #e0e0e0;
  background: #fff;
}

.flow-assistant-composer {
  border: 1px solid #e0e0e0;
  border-radius: 22px;
  background: #fff;
  padding: 6px 8px;
  box-shadow: none;
}

.flow-assistant-composer-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.flow-assistant-composer-field {
  flex: 1 1 auto;
}

.flow-assistant-composer-field textarea {
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  font: inherit;
  /* iOS Safari zooms form controls on focus when font-size is below 16px. */
  font-size: 16px;
  line-height: 24px;
  color: #212427;
  background: transparent;
  min-height: 24px;
  padding: 8px 0;
  margin: 0;
  display: block;
}

.flow-assistant-composer-field textarea::placeholder {
  color: #606060;
}

.flow-assistant-composer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.composer-icon,
.composer-send {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.composer-icon {
  background: transparent;
  color: #5ea1d8;
}

.composer-send {
  background: #5ea1d8;
  color: #fff;
  box-shadow: 0 4px 10px rgba(94, 161, 216, 0.28);
}

.composer-send mat-icon {
  line-height: 20px;
}

.composer-send:disabled {
  opacity: 0.6;
  box-shadow: none;
}

.flow-assistant-footer-note {
  font-size: 11px;
  color: #606060;
  padding: 0 2px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.footer-doc-icon {
  font-size: 13px !important;
  width: 13px !important;
  height: 13px !important;
  line-height: 13px !important;
  color: #5ea1d8;
}

/* ── Document toggle row ── */
.flow-assistant-doc-toggle-row {
  display: flex;
  align-items: center;
}

.doc-toggle-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px 5px 8px;
  border-radius: 999px;
  border: 1.5px solid #e0e0e0;
  background: #f5f5f5;
  color: #606060;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.18s, background 0.18s, color 0.18s;
  line-height: 1;
}

.doc-toggle-pill:hover {
  border-color: #5ea1d8;
  background: #eef6fd;
  color: #5ea1d8;
}

.doc-toggle-pill--active {
  border-color: #5ea1d8;
  background: #eef6fd;
  color: #1565c0;
}

.doc-toggle-icon {
  font-size: 15px !important;
  width: 15px !important;
  height: 15px !important;
  line-height: 15px !important;
  color: inherit;
}

.doc-toggle-label {
  flex: 1 1 auto;
}

.doc-toggle-count {
  font-size: 11px;
  opacity: 0.7;
}

.doc-toggle-status-icon {
  font-size: 20px !important;
  width: 20px !important;
  height: 20px !important;
  line-height: 20px !important;
  color: inherit;
  margin-left: 2px;
}

/* ── Document chip list ── */
.flow-assistant-doc-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  padding: 4px 2px 2px;
}

.doc-list-label {
  font-size: 11px;
  color: #606060;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.doc-list-chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px 3px 5px;
  border-radius: 999px;
  background: #e3f0fb;
  color: #1565c0;
  font-size: 11px;
  font-weight: 500;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-chip-icon {
  font-size: 12px !important;
  width: 12px !important;
  height: 12px !important;
  line-height: 12px !important;
  flex-shrink: 0;
}

/* Composer highlight when doc mode is active */
.flow-assistant-composer--doc-mode {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);
}

.flow-assistant-modal-backdrop {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(15, 23, 42, 0.48);
  z-index: 20;
  pointer-events: auto;
}

.flow-assistant-modal {
  width: min(100%, 360px);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  padding: 20px;
  border: 1px solid #e0e0e0;
}

.flow-assistant-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #212427;
}

.flow-assistant-modal-text {
  margin: 12px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: #606060;
}

.flow-assistant-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

@media (max-width: 767px) {
  .flow-assistant-root {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100vh;
    z-index: 1005;
  }
  .flow-assistant-panel {
    width: 100vw;
    height: 100vh;
    border-left: none;
    box-shadow: none;
  }
  .flow-assistant-header {
    padding-top: 16px;
  }
  .flow-assistant-line .bubble {
    max-width: 92%;
  }
  .flow-assistant-modal-backdrop {
    padding: 16px;
  }
  .flow-assistant-modal {
    width: 100%;
    max-width: 100%;
  }
}
/* Dark theme */
:host-context(body.theme-dark) .flow-assistant-panel {
  background: #0f172a;
  border-left: 1px solid rgba(148, 163, 184, 0.25);
  box-shadow: -10px 0 24px rgba(0, 0, 0, 0.45);
}
:host-context(body.theme-dark) .flow-assistant-header,
:host-context(body.theme-dark) .flow-assistant-banner,
:host-context(body.theme-dark) .flow-assistant-input-row {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.25);
}
:host-context(body.theme-dark) .flow-assistant-title,
:host-context(body.theme-dark) .flow-assistant-subtitle,
:host-context(body.theme-dark) .flow-assistant-hint,
:host-context(body.theme-dark) .flow-assistant-hint-title,
:host-context(body.theme-dark) .flow-assistant-footer-note,
:host-context(body.theme-dark) .flow-assistant-meta,
:host-context(body.theme-dark) .citations-label,
:host-context(body.theme-dark) .citation-text,
:host-context(body.theme-dark) .suggestion-title {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .flow-assistant-header-icon--close {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .flow-assistant-header-icon:hover {
  background: rgba(148, 163, 184, 0.14);
}
:host-context(body.theme-dark) .flow-assistant-messages {
  background: #0b1220;
}
:host-context(body.theme-dark) .flow-assistant-welcome-card,
:host-context(body.theme-dark) .suggestion-card,
:host-context(body.theme-dark) .flow-assistant-line.assistant .bubble {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.25);
  color: #e5e7eb;
}
:host-context(body.theme-dark) .suggestion-card--primary {
  background: #1f2937;
  border-color: #5ea1d8;
}
:host-context(body.theme-dark) .suggestion-action {
  background: #5ea1d8;
  color: #ffffff;
}
:host-context(body.theme-dark) .suggestion-card:not(.suggestion-card--primary) .suggestion-action {
  background: #111827;
  color: #93c5fd;
  border-color: #5ea1d8;
}
:host-context(body.theme-dark) .flow-assistant-line.user .bubble {
  background: #5ea1d8;
  color: #ffffff;
}
:host-context(body.theme-dark) .flow-assistant-error {
  color: #fecaca;
  background: rgba(127, 29, 29, 0.45);
}
:host-context(body.theme-dark) .flow-assistant-composer {
  background: #0f172a;
  border-color: rgba(148, 163, 184, 0.35);
}
:host-context(body.theme-dark) .flow-assistant-composer-field textarea {
  color: #f9fafb;
}
:host-context(body.theme-dark) .flow-assistant-composer-field textarea::placeholder {
  color: #9ca3af;
}
:host-context(body.theme-dark) .composer-icon {
  color: #93c5fd;
}
:host-context(body.theme-dark) .composer-send {
  background: #5ea1d8;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .flow-assistant-modal {
  background: #111827;
  border-color: rgba(148, 163, 184, 0.25);
}
:host-context(body.theme-dark) .flow-assistant-modal-header h3,
:host-context(body.theme-dark) .flow-assistant-modal-text {
  color: #e5e7eb;
}
:host-context(body.theme-dark) .doc-toggle-pill {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.3);
  color: #9ca3af;
}
:host-context(body.theme-dark) .doc-toggle-pill:hover,
:host-context(body.theme-dark) .doc-toggle-pill--active {
  border-color: #5ea1d8;
  background: #162032;
  color: #93c5fd;
}
:host-context(body.theme-dark) .doc-list-chip {
  background: #162032;
  color: #93c5fd;
}
:host-context(body.theme-dark) .doc-list-label {
  color: #9ca3af;
}
:host-context(body.theme-dark) .flow-assistant-composer--doc-mode {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);
}
:host-context(body.theme-dark) .footer-doc-icon {
  color: #93c5fd;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/flow-assistant-chat/flow-assistant-chat.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,0BAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;AAEF;;AACA,wEAAA;AACA;EACE,mEAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,8BAAA;EACA,gBAAA;EACA,oBAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,gCAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,oCAAA;AAEF;;AACA;EACE,mCAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,8CAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAEF;;AACA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAEF;;AACA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAEF;;AACA;EACE,uBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAEF;;AACA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAEF;;AACA;EACE,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAEF;;AACA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAEF;;AACA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AACA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAEF;;AACA;EACE,SAAA;EACA,uBAAA;EACA,gCAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAEF;;AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,0DAAA;AAEF;;AACA;EACE,qBAAA;EACA,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAEF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,mBAAA;EACA,qBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;AAEF;;AACA;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yCAAA;AAEF;;AACA;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AAEF;;AACA;EACE,mBAAA;EACA,yBAAA;EACA,WAAA;AAEF;;AACA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAEF;;AACA;EACE,yBAAA;AAEF;;AACA;EACE,cAAA;EACA,qBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;AAEF;;AACA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;AAEF;;AACA;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,0EAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;AAEF;;AACA;;EAEE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,uBAAA;EACA,cAAA;AAEF;;AACA;EACE,mBAAA;EACA,WAAA;EACA,+CAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAEF;;AACA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAEF;;AACA,8BAAA;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6DAAA;EACA,cAAA;AAEF;;AACA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAEF;;AACA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AAEF;;AACA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,eAAA;EACA,YAAA;AAEF;;AACA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;AAEF;;AACA,6BAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;AAEF;;AACA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAEF;;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,cAAA;AAEF;;AACA,+CAAA;AACA;EACE,qBAAA;EACA,8CAAA;AAEF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kCAAA;EACA,WAAA;EACA,oBAAA;AACF;;AAEA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;IACA,aAAA;IACA,aAAA;EACF;EAEA;IACE,YAAA;IACA,aAAA;IACA,iBAAA;IACA,gBAAA;EAAF;EAGA;IACE,iBAAA;EADF;EAIA;IACE,cAAA;EAFF;EAKA;IACE,aAAA;EAHF;EAMA;IACE,WAAA;IACA,eAAA;EAJF;AACF;AAOA,eAAA;AAEE;EACE,mBAAA;EACA,gDAAA;EACA,4CAAA;AANJ;AASE;;;EAGE,mBAAA;EACA,uCAAA;AAPJ;AAUE;;;;;;;;;EASE,cAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAYE;EACE,qCAAA;AAVJ;AAaE;EACE,mBAAA;AAXJ;AAcE;;;EAGE,mBAAA;EACA,uCAAA;EACA,cAAA;AAZJ;AAeE;EACE,mBAAA;EACA,qBAAA;AAbJ;AAgBE;EACE,mBAAA;EACA,cAAA;AAdJ;AAiBE;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAfJ;AAkBE;EACE,mBAAA;EACA,cAAA;AAhBJ;AAmBE;EACE,cAAA;EACA,mCAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,uCAAA;AAlBJ;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,cAAA;AApBJ;AAuBE;EACE,cAAA;AArBJ;AAwBE;EACE,mBAAA;EACA,cAAA;EACA,+CAAA;AAtBJ;AAyBE;EACE,mBAAA;EACA,uCAAA;AAvBJ;AA0BE;;EAEE,cAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,sCAAA;EACA,cAAA;AAzBJ;AA4BE;;EAEE,qBAAA;EACA,mBAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,mBAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,cAAA;AA5BJ;AA+BE;EACE,qBAAA;EACA,6CAAA;AA7BJ;AAgCE;EACE,cAAA;AA9BJ","sourcesContent":[".flow-assistant-root {\n  position: fixed;\n  right: 0;\n  top: 64px;\n  height: calc(100vh - 64px);\n  z-index: 990;\n  font-family: inherit;\n  pointer-events: none;\n}\n\n/* Keep chatbot icons aligned with app-wide Material icon sizing/font. */\n.flow-assistant-root mat-icon {\n  font-family: \"Material Icons\", \"Material Icons Outlined\" !important;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n\n.flow-assistant-panel {\n  position: relative;\n  width: min(400px, 32vw);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  box-shadow: -8px 0 20px rgba(0, 0, 0, 0.08);\n  border-left: 1px solid #e0e0e0;\n  overflow: hidden;\n  pointer-events: auto;\n}\n\n.flow-assistant-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 18px 16px 14px;\n  background: #fff;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.flow-assistant-header-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.flow-assistant-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.flow-assistant-header-icon {\n  color: #5ea1d8;\n}\n\n.flow-assistant-header-icon mat-icon {\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n\n.flow-assistant-header-icon--close {\n  color: #212427;\n}\n\n.flow-assistant-header-icon--delete {\n  color: #d32f2f;\n}\n\n.flow-assistant-header-icon:hover {\n  background: #f5f5f5;\n}\n\n.flow-assistant-header-icon--close:hover {\n  background: rgba(94, 161, 216, 0.12);\n}\n\n.flow-assistant-header-icon--delete:hover {\n  background: rgba(211, 47, 47, 0.12);\n}\n\n.flow-assistant-avatar {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: #5ea1d8;\n  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n}\n\n.flow-assistant-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.flow-assistant-title {\n  font-weight: 700;\n  font-size: 18px;\n  color: #212427;\n}\n\n.flow-assistant-subtitle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #606060;\n}\n\n.status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #5ea1d8;\n  flex: 0 0 auto;\n}\n\n.flow-assistant-banner {\n  padding: 12px 16px 10px;\n  background: #fff;\n}\n\n.flow-assistant-banner-label {\n  margin-bottom: 6px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #5ea1d8;\n}\n\n.flow-assistant-hint {\n  margin: 0;\n  font-size: 12px;\n  color: #606060;\n  line-height: 1.45;\n}\n\n.flow-assistant-hint-title {\n  font-weight: 700 !important;\n  font-style: italic;\n  color: #212427;\n  display: inline;\n}\n\n.flow-assistant-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 14px;\n  background: #ffffff;\n}\n\n.flow-assistant-messages::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.flow-assistant-empty {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 6px 0 18px;\n}\n\n.flow-assistant-welcome-card {\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  padding: 18px 16px;\n  color: #212427;\n}\n\n.welcome-title {\n  margin: 0 0 8px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.welcome-text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.6;\n  color: #606060;\n}\n\n.flow-assistant-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #5ea1d8;\n}\n\n.flow-assistant-suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.flow-assistant-blogs {\n  margin: 0;\n  padding: 12px 16px 10px;\n  border-bottom: 1px solid #eef2f5;\n  background: #fafbfc;\n  flex-shrink: 0;\n  max-height: 160px;\n  overflow-y: auto;\n}\n\n.flow-assistant-blogs .flow-assistant-section-label {\n  margin-bottom: 8px;\n}\n\n.flow-assistant-blog-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.flow-assistant-blog-card {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  border: 1px solid #e0e0e0;\n  background: #fff;\n  border-radius: 14px;\n  padding: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.flow-assistant-blog-card:hover:not(:disabled) {\n  border-color: #5ea1d8;\n  background: #f7fbfe;\n}\n\n.flow-assistant-blog-card:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.flow-assistant-blog-cover {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  object-fit: cover;\n  flex-shrink: 0;\n  background: #f0f0f0;\n}\n\n.flow-assistant-blog-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.flow-assistant-blog-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #212427;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.flow-assistant-blog-author {\n  font-size: 11px;\n  color: #6b7280;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.suggestion-card {\n  width: 100%;\n  text-align: left;\n  border: 1px solid #e0e0e0;\n  background: #f5f5f5;\n  border-radius: 20px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.suggestion-card:disabled {\n  cursor: not-allowed;\n}\n\n.suggestion-card--primary {\n  background: #ffffff;\n  border-color: #5ea1d8;\n}\n\n.suggestion-title {\n  font-size: 14px;\n  line-height: 1.45;\n  color: #212427;\n}\n\n.suggestion-action {\n  align-self: flex-start;\n  min-width: 150px;\n  padding: 10px 18px;\n  border-radius: 999px;\n  background: #5ea1d8;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.suggestion-card:not(.suggestion-card--primary) .suggestion-action {\n  background: #fff;\n  color: #5ea1d8;\n  border: 1px solid #5ea1d8;\n}\n\n.flow-assistant-line {\n  margin-bottom: 12px;\n}\n\n.flow-assistant-line .bubble {\n  display: inline-block;\n  max-width: 88%;\n  padding: 10px 14px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.flow-assistant-line.user .bubble {\n  background: #5ea1d8;\n  color: #fff;\n  margin-left: auto;\n  float: right;\n  clear: both;\n}\n\n.flow-assistant-line.assistant .bubble {\n  background: #f5f5f5;\n  border: 1px solid #e0e0e0;\n  clear: both;\n}\n\n.flow-assistant-meta {\n  clear: both;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #606060;\n}\n\n.flow-assistant-line.user .flow-assistant-meta {\n  text-align: right;\n}\n\n.citations {\n  clear: both;\n  margin-top: 10px;\n  font-size: 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\n.citations-label {\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.citation-link {\n  color: #1976d2;\n  text-decoration: none;\n}\n\n.citation-link:hover {\n  text-decoration: underline;\n}\n\n.citation-text {\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.flow-assistant-loading {\n  display: flex;\n  justify-content: center;\n  padding: 12px;\n}\n\n.flow-assistant-error {\n  margin: 0 16px 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #c62828;\n  background: #ffebee;\n  border-radius: 12px;\n}\n\n.flow-assistant-input-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 14px 16px 16px;\n  border-top: 1px solid #e0e0e0;\n  background: #fff;\n}\n\n.flow-assistant-composer {\n  border: 1px solid #e0e0e0;\n  border-radius: 22px;\n  background: #fff;\n  padding: 6px 8px;\n  box-shadow: none;\n}\n\n.flow-assistant-composer-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.flow-assistant-composer-field {\n  flex: 1 1 auto;\n}\n\n.flow-assistant-composer-field textarea {\n  width: 100%;\n  border: none;\n  outline: none;\n  resize: none;\n  font: inherit;\n  /* iOS Safari zooms form controls on focus when font-size is below 16px. */\n  font-size: 16px;\n  line-height: 24px;\n  color: #212427;\n  background: transparent;\n  min-height: 24px;\n  padding: 8px 0;\n  margin: 0;\n  display: block;\n}\n\n.flow-assistant-composer-field textarea::placeholder {\n  color: #606060;\n}\n\n.flow-assistant-composer-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.composer-icon,\n.composer-send {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.composer-icon {\n  background: transparent;\n  color: #5ea1d8;\n}\n\n.composer-send {\n  background: #5ea1d8;\n  color: #fff;\n  box-shadow: 0 4px 10px rgba(94, 161, 216, 0.28);\n}\n\n.composer-send mat-icon {\n  line-height: 20px;\n}\n\n.composer-send:disabled {\n  opacity: 0.6;\n  box-shadow: none;\n}\n\n.flow-assistant-footer-note {\n  font-size: 11px;\n  color: #606060;\n  padding: 0 2px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.footer-doc-icon {\n  font-size: 13px !important;\n  width: 13px !important;\n  height: 13px !important;\n  line-height: 13px !important;\n  color: #5ea1d8;\n}\n\n/* ── Document toggle row ── */\n.flow-assistant-doc-toggle-row {\n  display: flex;\n  align-items: center;\n}\n\n.doc-toggle-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px 5px 8px;\n  border-radius: 999px;\n  border: 1.5px solid #e0e0e0;\n  background: #f5f5f5;\n  color: #606060;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: border-color 0.18s, background 0.18s, color 0.18s;\n  line-height: 1;\n}\n\n.doc-toggle-pill:hover {\n  border-color: #5ea1d8;\n  background: #eef6fd;\n  color: #5ea1d8;\n}\n\n.doc-toggle-pill--active {\n  border-color: #5ea1d8;\n  background: #eef6fd;\n  color: #1565c0;\n}\n\n.doc-toggle-icon {\n  font-size: 15px !important;\n  width: 15px !important;\n  height: 15px !important;\n  line-height: 15px !important;\n  color: inherit;\n}\n\n.doc-toggle-label {\n  flex: 1 1 auto;\n}\n\n.doc-toggle-count {\n  font-size: 11px;\n  opacity: 0.7;\n}\n\n.doc-toggle-status-icon {\n  font-size: 20px !important;\n  width: 20px !important;\n  height: 20px !important;\n  line-height: 20px !important;\n  color: inherit;\n  margin-left: 2px;\n}\n\n/* ── Document chip list ── */\n.flow-assistant-doc-list {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 2px 2px;\n}\n\n.doc-list-label {\n  font-size: 11px;\n  color: #606060;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.doc-list-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 8px 3px 5px;\n  border-radius: 999px;\n  background: #e3f0fb;\n  color: #1565c0;\n  font-size: 11px;\n  font-weight: 500;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.doc-chip-icon {\n  font-size: 12px !important;\n  width: 12px !important;\n  height: 12px !important;\n  line-height: 12px !important;\n  flex-shrink: 0;\n}\n\n/* Composer highlight when doc mode is active */\n.flow-assistant-composer--doc-mode {\n  border-color: #5ea1d8;\n  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.15);\n}\n\n\n.flow-assistant-modal-backdrop {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  background: rgba(15, 23, 42, 0.48);\n  z-index: 20;\n  pointer-events: auto;\n}\n\n.flow-assistant-modal {\n  width: min(100%, 360px);\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);\n  padding: 20px;\n  border: 1px solid #e0e0e0;\n}\n\n.flow-assistant-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #212427;\n}\n\n.flow-assistant-modal-text {\n  margin: 12px 0 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #606060;\n}\n\n.flow-assistant-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n@media (max-width: 767px) {\n  .flow-assistant-root {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    height: 100vh;\n    z-index: 1005;\n  }\n\n  .flow-assistant-panel {\n    width: 100vw;\n    height: 100vh;\n    border-left: none;\n    box-shadow: none;\n  }\n\n  .flow-assistant-header {\n    padding-top: 16px;\n  }\n\n  .flow-assistant-line .bubble {\n    max-width: 92%;\n  }\n\n  .flow-assistant-modal-backdrop {\n    padding: 16px;\n  }\n\n  .flow-assistant-modal {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* Dark theme */\n:host-context(body.theme-dark) {\n  .flow-assistant-panel {\n    background: #0f172a;\n    border-left: 1px solid rgba(148, 163, 184, 0.25);\n    box-shadow: -10px 0 24px rgba(0, 0, 0, 0.45);\n  }\n\n  .flow-assistant-header,\n  .flow-assistant-banner,\n  .flow-assistant-input-row {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.25);\n  }\n\n  .flow-assistant-title,\n  .flow-assistant-subtitle,\n  .flow-assistant-hint,\n  .flow-assistant-hint-title,\n  .flow-assistant-footer-note,\n  .flow-assistant-meta,\n  .citations-label,\n  .citation-text,\n  .suggestion-title {\n    color: #e5e7eb;\n  }\n\n  .flow-assistant-header-icon--close {\n    color: #e5e7eb;\n  }\n\n  .flow-assistant-header-icon:hover {\n    background: rgba(148, 163, 184, 0.14);\n  }\n\n  .flow-assistant-messages {\n    background: #0b1220;\n  }\n\n  .flow-assistant-welcome-card,\n  .suggestion-card,\n  .flow-assistant-line.assistant .bubble {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.25);\n    color: #e5e7eb;\n  }\n\n  .suggestion-card--primary {\n    background: #1f2937;\n    border-color: #5ea1d8;\n  }\n\n  .suggestion-action {\n    background: #5ea1d8;\n    color: #ffffff;\n  }\n\n  .suggestion-card:not(.suggestion-card--primary) .suggestion-action {\n    background: #111827;\n    color: #93c5fd;\n    border-color: #5ea1d8;\n  }\n\n  .flow-assistant-line.user .bubble {\n    background: #5ea1d8;\n    color: #ffffff;\n  }\n\n  .flow-assistant-error {\n    color: #fecaca;\n    background: rgba(127, 29, 29, 0.45);\n  }\n\n  .flow-assistant-composer {\n    background: #0f172a;\n    border-color: rgba(148, 163, 184, 0.35);\n  }\n\n  .flow-assistant-composer-field textarea {\n    color: #f9fafb;\n  }\n\n  .flow-assistant-composer-field textarea::placeholder {\n    color: #9ca3af;\n  }\n\n  .composer-icon {\n    color: #93c5fd;\n  }\n\n  .composer-send {\n    background: #5ea1d8;\n    color: #ffffff;\n    box-shadow: 0 4px 12px rgba(94, 161, 216, 0.35);\n  }\n\n  .flow-assistant-modal {\n    background: #111827;\n    border-color: rgba(148, 163, 184, 0.25);\n  }\n\n  .flow-assistant-modal-header h3,\n  .flow-assistant-modal-text {\n    color: #e5e7eb;\n  }\n\n  .doc-toggle-pill {\n    background: #1f2937;\n    border-color: rgba(148, 163, 184, 0.3);\n    color: #9ca3af;\n  }\n\n  .doc-toggle-pill:hover,\n  .doc-toggle-pill--active {\n    border-color: #5ea1d8;\n    background: #162032;\n    color: #93c5fd;\n  }\n\n  .doc-list-chip {\n    background: #162032;\n    color: #93c5fd;\n  }\n\n  .doc-list-label {\n    color: #9ca3af;\n  }\n\n  .flow-assistant-composer--doc-mode {\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);\n  }\n\n  .footer-doc-icon {\n    color: #93c5fd;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
